<div class="header">
  <div class="row">
    <div class="col-md">
      <h3>{{'MENU.EMAIL-DASHBOARD' | translate}}</h3>
      <h6>{{'CHART.TOTAL' | translate}}: {{emailTotal}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
    </div>
  </div>
</div>

<div class="row mr-0">
  <div class="col-3  d-flex flex-row">
    <div class="ts-box sentChart flex-column" [ngClass]="{'selected-sentChart': docType === 'sent'}"
         (click)="filterStatus('success')" style="overflow: hidden">
      <h5 class="text-center mt-2 mb-0">{{'EMAIL-DASHBOARD.SENT' | translate}}</h5>
      <div class="canvas mt-4">
        <canvas id="sentChart">{{myChart1}}</canvas>
      </div>
      <h6 class="text-center mb-2">{{emailSent}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
    </div>
    <div class="ts-box errorsChart flex-column" [ngClass]="{'selected-errorsChart': docType === 'errors'}"
         (click)="filterStatus('failed')" style="overflow: hidden">
      <h5 class="text-center mt-2 mb-0">{{'EMAIL-DASHBOARD.FAILED' | translate}}</h5>
      <div class="canvas mt-4">
        <canvas id="errorChart">{{myChart2}}</canvas>
      </div>
      <h6 class="text-center mb-2">{{emailSendFailed}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
    </div>
  </div>
  <div class="box-filter col-9">
    <div class="col-12 searchBox_inner">
      <app-filter-header [loading]="loading" (search)="searchButtonClicked()"
                         (clear)="clearData()"></app-filter-header>
    </div>
    <div class="row row-eq-height">
      <div class="col-4 pl-3 pr-0">
        <div class="dropdown-label-group">
          <p-dropdown
            class="dv-dropdown"
            selectId="company"
            [options]="company"
            [(ngModel)]="selectedCompany"
            (onChange)="filterBranchList()"
            [autoDisplayFirst]="false"
            id="company"
            placeholder="{{'FILTER.COMPANY' | translate}}"
            [style]="{'z-index': 3}">
          </p-dropdown>
          <label for="company">{{'FILTER.COMPANY' | translate}}</label>
        </div>
      </div>
      <div class="col-4 px-2">
        <div class="center">
          <div class="dropdown-label-group">
            <p-dropdown
              class="dv-dropdown"
              selectId="companyBranch"
              [options]="branchList"
              [(ngModel)]="selectedBranch"
              [autoDisplayFirst]="false"
              id="branch"
              placeholder="{{'FILTER.BRANCH' | translate}}">
            </p-dropdown>
            <label for="branch">{{'FILTER.BRANCH' | translate}}</label>
          </div>
        </div>
      </div>
      <div class="col-4 pr-3 pl-0">
        <div class="center">
          <div class="dropdown-label-group">
            <p-dropdown
              class="dv-dropdown"
              selectId="documentType"
              [options]="rdDocumentType"
              [(ngModel)]="selectedRdDocumentType"
              [autoDisplayFirst]="false"
              id="documentType"
              placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}"
            >
            </p-dropdown>
            <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
          </div>
        </div>
      </div>
      <div class="col-4 pl-3 pr-0">
        <div style="padding-top: 5px">
          <div class="form-label-group form-group">
            <input class="form-control" type="text" id="documentNumber" [(ngModel)]="documentNumber"
                   placeholder="{{ 'EMAIL-DASHBOARD.DOC-NUM' | translate }}">
            <label for="documentNumber">{{ 'EMAIL-DASHBOARD.DOC-NUM' | translate }}</label>
          </div>
        </div>
      </div>
      <div class="col-4 px-2 h-50">
        <div class="center">
          <div style="padding-top: 5px">
            <ng-select class="custom" [items]="allBuyerEmailsReport"
                       id="email"
                       bindLabel=label
                       placeholder="Select email"
                       [(ngModel)]="email"
                       [ngClass]="{'selected': searching || email}"
                       (blur)="searching = false"
                       (focus)="searching = true">
            </ng-select>
            <label *ngIf="searching || email" class="select-label"
                   for="email">{{ 'EMAIL-DASHBOARD.EMAIL' | translate }}</label>
          </div>
        </div>
      </div>
      <div class="col-4 pr-3 pl-0">
        <div class="center">
          <div style="padding-top: 5px">
            <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
              <div class="form-label-group form-group">
                <input class="form-control" type="text" id="sentEmailCalendarDropdown" [value]="dateRange"
                       ngbDropdownToggle placeholder="{{'EMAIL-DASHBOARD.SENT-DATE' | translate}}" readonly>
                <label for="sentEmailCalendarDropdown">{{'EMAIL-DASHBOARD.SENT-DATE' | translate}}</label>
                <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
                  <span class="far fa-calendar"></span>
                </div>
              </div>
              <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
                <div class="row">
                  <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
                  <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
                </div>
                <div (click)="stopPropagation($event)">
                  <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy"
                              readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                              [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                              [locale]="calendarLocale"></p-calendar>
                  <p-calendar [(ngModel)]="endDate" [defaultDate]="endDate" dateFormat="dd/mm/yy"
                              readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                              [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                              [locale]="calendarLocale"></p-calendar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="col-12 box-parent  mt-3 pr-0 pl-0">
  <div class="pl-2">
    <app-custom-pagination
      [(currentPage)]="currentPage"
      [(itemsPerPage)]="itemsPerPage"
      [totalItems]="totalItems"
      (pageChange)="pageChanged()"
      (optionChange)="searchButtonClicked()"
      *ngIf="loading_main === false && totalItems !== 0"
    >
    </app-custom-pagination>
  </div>

  <div class="row m-t-20" *ngIf="totalItems === 0 && loading_main === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="col-12 m-t-20 text-center scrollable padding-left pl-0 pr-0" *ngIf="!loading_main&&totalItems !== 0">
    <p-table #tt tableStyleClass="table" *ngIf="totalItems !== 0" [loading]="loading"
             [columns]="tableCol" [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
          </th>
          <th scope="col">{{'NORMAL.EMAIL' | translate}}</th>
          <th scope="col">{{'NORMAL.CC' | translate}}</th>
          <th pSortableColumn="status" scope="col" (click)="pageChanged()">{{'EMAIL-DASHBOARD.STATUS' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td class="align-middle">{{data.sent_date| date:"dd/MM/yyyy"}}</td>
          <td class="align-middle">{{data.document_number}}</td>
          <td class="align-middle">{{(currentLang === 'en' ? data.document_type : data.document_type_th)}}</td>
          <td class="text-left">
            <ul *ngFor="let res of data.to_email_data; let i = index">
              <li>
                {{res}}
              </li>
            </ul>
          </td>
          <td class="text-left">
            <ul *ngFor="let res of data.cc_email_data; let i = index">
              <li>
                {{res}}
              </li>
            </ul>
          </td>
          <td class="align-middle" *ngIf="data.status=='failed'"><i class="fa fa-circle" style="color: #FF6384"
                                                                    aria-hidden="true"></i></td>
          <td class="align-middle" *ngIf="data.status=='success'"><i class="fa fa-circle" style="color: #16c8c8"
                                                                     aria-hidden="true"></i></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="row m-t-20" *ngIf="loading_main">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.html